import { fieldValidation, isFieldsValid } from "./field-validation";

export const getAdjustedToCignaAppData = (appData, conditionals, fields) => {
  // You should add your own handler name for each of new cases
  const RUN_FIELD_ACTION_MATCHING_CONSTANTS = {
    date_time: "fetchAvailableTimes"
  };

  const runFieldActionMatches =
    conditionals?.filter(({ type }) => type === "runFieldAction") || [];

  const runFieldActions = runFieldActionMatches.reduce(
    (accumulator, { fieldName, value }) => {
      const action = fields.find(field => field.name === value)?.action;
      const matchedCalbackName = RUN_FIELD_ACTION_MATCHING_CONSTANTS[value];
      const runFieldActionValue = {
        action,
        calbackName: matchedCalbackName,
        runningFieldName: value
      };

      return {
        ...accumulator,
        [fieldName]: runFieldActionValue,
        [value]: runFieldActionValue
      };
    },
    {}
  );
  const isRunFieldActions = !!Object.keys(runFieldActions).length;

  return !isRunFieldActions
    ? appData
    : {
        ...appData,
        runFieldActions
      };
};

export const getAdjustedToCignaFields = fields =>
  fields.map(field => {
    if (field.type === "formDateTimePicker") {
      return {
        ...field,
        type: "dateTimePicker"
      };
    }

    return field;
  });

export const getAdjustedToCignaField = (field, appData) => {
  const runFieldActions = appData?.runFieldActions || {};
  const isRunFieldActions = !!Object.keys(runFieldActions).length;
  const hasFieldRunFieldAction =
    isRunFieldActions && runFieldActions[field.name];

  if (!hasFieldRunFieldAction) {
    return field;
  } else {
    const {
      calbackName: matchedRunFieldActionCallbackName,
      action: matchedRunFieldActionAction,
      runningFieldName
    } = runFieldActions[field.name];

    const runFieldAction = newData => {
      const matchedCallback = appData[matchedRunFieldActionCallbackName];

      matchedCallback({
        newData,
        action: matchedRunFieldActionAction,
        runningFieldName
      });
    };

    return {
      ...field,
      runFieldAction
    };
  }
};

export const getAdjustedToCignaErrorText = (error, settings) =>
  !error.message.includes("no_video_times_available")
    ? error.message
    : settings.translations.no_times_available;

// Validation helpers
const getDateTimeObjectForDateTimeValidation = ({
  dateValue,
  dateFieldName,
  timeValue,
  timeFieldName
}) => ({
  date: { value: dateValue, fieldName: dateFieldName },
  time: { value: timeValue, fieldName: timeFieldName }
});

export const dateTimeFieldValidationUpdate = ({
  field,
  appData,
  dateValue,
  dateFieldName,
  timeValue,
  timeFieldName,
  needImmediateApply = false,
  fieldRef
}) => {
  const extraValidationData = getDateTimeObjectForDateTimeValidation({
    dateValue,
    dateFieldName,
    timeValue,
    timeFieldName
  });

  fieldValidation[field.type].update(field, appData, {
    ...extraValidationData,
    fieldRef
  });

  if (needImmediateApply) {
    isFieldsValid(appData);
  }
};
